import { Component, Input, OnInit, inject } from '@angular/core';
import { CustomRouter, SystemPreferencesService } from '@lib/core';
import { EnvService } from '@lib/env';
import { SubscriptionHelper } from '@lib/util';

@Component({
    selector: 'smart-logo',
    templateUrl: './logo.component.html',
    standalone: false
})
export class LogoComponent extends SubscriptionHelper implements OnInit {
    readonly preferencesService = inject(SystemPreferencesService);
    private readonly router = inject(CustomRouter);

    public env = EnvService;

    @Input() public isDeeplink = false;
    public logo: Blob;

    public ngOnInit(): void {
        this.getLogo();
        if (this.router.url.includes('deep')) {
            this.isDeeplink = true;
        }
    }

    private getLogo(): void {
        this.preferencesService.companyLogo$.subscribe((logo) => (this.logo = logo));
    }
}
